'use client'
import Link from 'next/link'
import { Search, Menu } from 'lucide-react'
import Image from 'next/image'
import logoTeal from '@/images/logo-teal.svg'
import './styles.scss'
import { useSidebarContext } from '@/contexts/SideBarContext'

export const Header = () => {
  const { toggle: toggleSidebar } = useSidebarContext()
  return (
    <header className="header-new">
      <div className="header-mobile-controls">
        <button
          className="header-hamburger-btn"
          onClick={() => toggleSidebar()}
          aria-label="Abrir menu"
        >
          <Menu size={24} />
        </button>
      </div>

      <nav className="header-menu-left">
        <Link href="/" prefetch={false}>
          Home
        </Link>
        <Link href="/quem-somos" prefetch={false}>
          Quem Somos
        </Link>
        <Link href="/contato" prefetch={false}>
          Contato
        </Link>
      </nav>

      <div className="header-logo-wrapper">
        <Link href="/" prefetch={false}>
          <Image
            src={logoTeal.src}
            alt="Camargo Máquinas"
            width={332}
            height={49}
            priority
          />
        </Link>
      </div>

      <nav className="header-menu-right">
        <Link href="/products/1" prefetch={false}>
          Comprar
        </Link>
        <Link href="/vendedores" prefetch={false}>
          Vender
        </Link>
        <Link href="/seja-nosso-parceiro" prefetch={false}>
          Trabalhe Conosco
        </Link>
      </nav>

      <div className="header-mobile-controls">
        <Link
          href="/products/1"
          className="header-search-btn"
          prefetch={false}
          aria-label="Buscar"
        >
          <Search size={24} />
        </Link>
      </div>
    </header>
  )
}
